// 桜花びらが舞うレイヤー。背景の上に重ねて使う。

const PETALS = Array.from({ length: 14 }, (_, i) => ({
  left: (i * 7 + 5) % 100,
  delay: (i * 1.7) % 8,
  duration: 9 + ((i * 1.3) % 5),
  swayDuration: 3 + ((i * 0.7) % 3),
  size: 12 + ((i * 3) % 10),
}));

export function SakuraField() {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none z-10">
      {PETALS.map((p, i) => (
        <span
          key={i}
          className="sakura-petal"
          style={{
            left: `${p.left}%`,
            width: `${p.size}px`,
            height: `${p.size}px`,
            animationDuration: `${p.duration}s, ${p.swayDuration}s`,
            animationDelay: `${p.delay}s, ${p.delay / 2}s`,
          }}
        />
      ))}
    </div>
  );
}
